import ToggleButtonRefinement from './ToggleButtonRefinement';
import SelectOptionRefinement from './SelectOptionRefinement';
import SingleSelectOptionRefinement from './SingleSelectOptionRefinement';
import CheckBoxRefinementList from './CheckBoxRefinementList';
import SQFeetRefinementList from './SQFeetRefinementList';
import {useTranslation} from "react-i18next";

export default function OtherProjectProperties() {

    const {t, i18n} = useTranslation();

    const sqSort = [
        '< 10,000',
        '10,000 - 50,000',
        '50,000 - 200,000',
        '200,000 +'
    ]

    return (
        <div className="form-default">
            <div className="form__row">
                <ToggleButtonRefinement attribute="is_award_winner" label="Wood Design Award Winner" value={true}/>
                <CheckBoxRefinementList operator="or" attribute="other_property_names" limit={20}
                                        initialFacets={window.all_project_properties}/>
                {/*ToggleButtonRefinement attribute="is_spec_office" label="Spec Office" value={true} />
          <ToggleButtonRefinement attribute="is_affordable_housing" label="Affordable Housing" value={true} />*/}
            </div>
            <div className="form__row">

            </div>
            <div className="form__row" style={{display: 'flex'}}>
                <div className="form__group col-1of2">
                    <label className="form__label" htmlFor="material-exp">{t('Stories')}</label>
                    <div className="field-default">
                        <SelectOptionRefinement attribute="story_count"/>
                    </div>
                </div>

                <div className="form__group col-2of2" style={{margin: 'auto'}}>
                    <label className="form__label" htmlFor="material-exp">{t('Year.Built')}</label>
                    <div className="field-default">
                        <SingleSelectOptionRefinement attribute="year_built_date" operator="or"/>
                    </div>
                </div>


            </div>
            <div className="form__row">
                <div className="form__group col-1of2-lg">
                    <label className="form__label" htmlFor="material-exp">{t('Construction.Types')}</label>
                    <div className="checkboxes checkboxes--two-cols">
                        <CheckBoxRefinementList operator="or" attribute="construction_type_name" limit={20}
                                                initialFacets={window.all_construction_types}/>
                    </div>
                </div>
            </div>
            <div className="form__row">
                <div className="form__group">
                    <SQFeetRefinementList />
                </div>
            </div>
        </div>
    );
}
